module.exports = __webpack_public_path__ + "img/sk.ba9edfbc.svg";